// components/DropdownField.js
import React from 'react';

const DropdownField = ({ label, options, value, onChange, error }) => {
  return (
    <div className="dropdown-field">
      <label>{label}</label>
      <select value={value} onChange={onChange}>
        {options.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
      {error && <p className="error-text">{error}</p>} {/* Display error message */}
    </div>
  );
};

export default DropdownField;
